import ProposalPartial from "../../partials/proposal/proposal.partial";

export default function ProposalScreen() {
  return <ProposalPartial />;
}
